<app-add-form
  data-testid="batch-add-form"
  #addForm
  [title]="'batch_management.pages.add_batch' | translate"
  [formFields]="formFields()"
  [loading]="loading()"
  (formAction)="onFormAction($event.action)"
  (formValueChanges)="onFormValueChanges($event)"
>
</app-add-form>

<!-- Toast Messages -->
<p-toast data-testid="batch-add-toast"></p-toast>
